import { styled } from '@mui/material/styles';
import { Menu } from '@mui/material';

const PREFIX = 'NotificationMenu';

export const Classes = {
	subtitle: `${PREFIX}-subtitle`,
	menuList: `${PREFIX}-menuList`,
	header: `${PREFIX}-header`
};

export const StyledMenu = styled(Menu)(({ theme }) => ({
	width: '100%',
	height: '45%',

	[theme.breakpoints.up('sm')]: {
		width: '30%'
	},

	[`& .${Classes.header}`]: {
		backgroundColor: theme.palette.mode === 'light' ? '#1F4B76' : '#204B76',
		position: ' sticky',
		top: 0,
		zIndex: 1
	},

	[`& .${Classes.menuList}`]: {
		width: '100%'
	},

	'& .MuiPaper-root': {
		[theme.breakpoints.down('sm')]: {
			left: '20px !important'
		}
	},

	'& .MuiMenu-paper': {
		left: '20px',
		boxSizing: 'border-box',
		display: 'block',

		'&:hover::-webkit-scrollbar': {
			display: 'block'
		},
		'&::-webkit-scrollbar': {
			display: 'none',
			width: '0.412rem'
		},
		'&::-webkit-scrollbar-track': {
			boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
			webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: theme.palette.grey[600],
			borderRadius: '8px'
		}
	},

	'& .MuiList-root': {
		paddingTop: '0 !important',
		paddingBottom: '0 !important'
	},

	[`& .${Classes.subtitle}`]: {
		WebkitLineClamp: 3,
		whiteSpace: 'pre-wrap',
		overflow: 'hidden',
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		minWidth: '160px',

		[theme.breakpoints.between('750px', 'md')]: {
			minWidth: '250px'
		},
		[theme.breakpoints.up('lg')]: {
			minWidth: '300px'
		}
	}
}));
